import find from 'lodash/find';

const organizationHelpers = {
  getOrgPageTabs: ({ enabledTabKeys = [], isClr, hasPendingAffiliation, hasAffiliation, isPro, t, tabKey, orgSlug }) => {
    const emptyTab = [
      {
        hidden: true
      }
    ];

    // Define all possible tabs
    const allTabs = [
      {
        title: t('Organization page'),
        key: 'organization_page',
        redirect: `/org/${orgSlug}`
      },
      {
        title: t(isClr ? 'Staff' : 'Users'),
        key: 'users',
        redirect: `/org/${orgSlug}/${isClr ? 'staff' : 'users'}`
      },
      {
        title: t('Intake'),
        key: 'intake',
        redirect: `/org/${orgSlug}/intake`
      },
      {
        title: t('Referrals'),
        key: 'referrals',
        redirect: `/org/${orgSlug}/referrals`
      },
      {
        title: t('Clients'),
        key: 'clients',
        redirect: `/org/${orgSlug}/clients`
      },
      {
        title: t('Network Management'),
        key: 'network-management',
        redirect: `/org/${orgSlug}/network-management`
      },
      {
        title: t('Reports'),
        key: 'reports',
        redirect: `/org/${orgSlug}/reports`
      },
      {
        title: t('Settings'),
        key: 'settings',
        redirect: `/org/${orgSlug}/settings`
      }
    ];

    // Filter tabs to only include enabled ones
    let tabs = allTabs.filter((tab) => enabledTabKeys.includes(tab.key));

    tabs = isPro && (!hasAffiliation || hasPendingAffiliation) ? emptyTab : tabs;
    let found_tab = false;

    if (tabKey) {
      found_tab = find(tabs, (tab) => {
        return tab.key == tabKey;
      });
    }
    return { tabs, activeTab: found_tab || tabs[0] };
  }
};

export default organizationHelpers;
